<template>
  <div
    ref="root"
    :class="[{'blocked': isMovementBlocked}, 'tt-event']"
    :style="`left: ${left}px; width: ${width + reservationGap}px; height: ${height}px;`"
    @click.right.prevent="onRightClick"
    @click.stop="onClick"
    @mouseenter="mouseEnter"
    @mousemove="mouseMove"
    @mouseleave="mouseLeave"
  >
    <div
      v-if="!isNarrowWidth"
      class="tt-event--inner"
    >
      <svg
        v-if="isBlock"
        width="100%"
        height="100%"
      >
        <rect
          x="2"
          y="2"
          :width="width-4"
          :height="height-4"
          :stroke="strokeColor"
          :fill="fill"
          :fill-opacity="bgOpacity"
          stroke-width="1"
          rx="2"
        />
      </svg>
      <svg
        v-else
        width="100%"
        height="100%"
      >
        <!-- Fixed Ending -->
        <template v-if="reservation.fixedEnding">
          <rect
            v-if="reservationGap > 0"
            transform="translate(0.5,0.5)"
            x="2"
            y="2"
            :width="width-4 + reservationGap"
            :height="height-5"
            :stroke="gapBorderColor"
            :fill="gapColor"
            :opacity="gapOpacity"
            stroke-width="1"
            rx="2"
          />
          <rect
            transform="translate(0.5,0.5)"
            x="2"
            y="2"
            :width="width-4"
            :height="height-5"
            :stroke="strokeColor"
            :fill="fill"
            :fill-opacity="bgOpacity"
            stroke-width="1"
            rx="2"
          />
        </template>
        <!-- //Fixed Ending -->

        <!-- Fluid Ending -->
        <template v-if="!reservation.fixedEnding">
          <!-- Reservation Gap -->
          <path
            v-if="reservationGap > 0"
            transform="translate(0.5,0.5)"
            :d="bgPathGap"
            :stroke="gapBorderColor"
            :fill="gapColor"
            :opacity="gapOpacity"
            stroke-width="1"
          />
          <!-- Reservation Timeline item -->
          <path
            v-if="!reservation.fixedEnding"
            transform="translate(0.5,0.5)"
            :d="bgPath"
            :stroke="strokeColor"
            :fill="fill"
            :opacity="bgOpacity"
            stroke-width="1"
          />
        </template>
        <!-- //Fluid Ending -->
        <path
          transform="translate(0.5,0.5)"
          :d="partysizeBgPath"
          :stroke="strokeColor"
          :fill="strokeColor"
          stroke-width="1"
        />
      </svg>
      <!--  -->
      <div
        :style="`position: absolute; width: calc(${width}px * 0.95)`"
        class="d-flex align-center"
      >
        <div
          v-if="!isBlock"
          class="text-center font-weight-bold flex-shrink-0 flex-grow-0 tt-reservation-partysize"
        >
          {{ reservation.partySize }}
        </div>
        <div
          v-if="reservation.isFlagged"
          style="width: 16px"
          class="text-center flex-shrink-0 flex-grow-0"
        >
          <v-icon
            class="tt-event-icon"
            size="8px"
            color="yellow"
          >
            mdi-circle
          </v-icon>
        </div>
        <!--  -->
        <div
          v-if="reservation.isStarred"
          style="width: 20px"
          class="text-center flex-shrink-0 flex-grow-0"
        >
          <v-icon
            class="tt-event-icon"
            size="16px"
            color="white"
          >
            mdi-star
          </v-icon>
        </div>
        <!--  -->
        <div class="pl-1 text-body-1 tt-reservation-name mr-1">
          <v-icon
            v-if="reservation.contact.isVIP"
            class="white--text"
            style="margin-bottom:2px"
            small
          >
            mdi-crown
          </v-icon>
          {{ reservation.contact.name }}
          <sup v-if="reservation.contact.reservationCount || 0 > 0">
            {{ reservation.contact.reservationCount }}
          </sup>
        </div>
        <!-- Service Chip -->
        <div
          v-if="reservation.service"
          class="tt-reservation-service"
        >
          <v-chip
            class="tt-event-icon ml-1 py-0 px-1"
            label
            :color="reservation.service.color"
            :text-color="contrastForColor(reservation.service.color)"
            x-small
          >
            <span class="overflow-hidden">
              {{ reservation.service.title }}
            </span>
          </v-chip>
        </div>
        <!--  -->
        <div class="d-block">
          <span style="opacity: 0">.</span>
        </div>
        <!-- Reservation Label Chip -->
        <v-icon
          v-if="reservation.label"
          :color="colorForLabel"
          style="font-size: 27px"
        >
          {{ colorForLabel === '#FFFFFF' ? 'mdi-label-outline' : 'mdi-label' }}
        </v-icon>
        <!-- Payment Chip -->
        <v-chip
          v-if="reservation.paymentInfo"
          class="tt-chip-compact ml-1"
          label
          color="yellow"
          text-color="yellow darken-4"
          x-small
        >
          <div class="inner-content">
            $
          </div>
        </v-chip>

        <div :class="['ml-1 text-caption tt-reservation-note', {'tt-block': isBlock}]">
          <span>{{ reservation.notes }}</span>
        </div>
      </div>
    </div>
    <!-- Copmact (Narrow) View -->
    <div
      v-else
      class="tt-event--inner"
    >
      <svg
        width="100%"
        height="100%"
      >
        <template v-if="reservation.fixedEnding">
          <rect
            v-if="reservationGap > 0"
            transform="translate(0.5,0.5)"
            x="2"
            y="2"
            :width="width-4 + reservationGap"
            :height="height-5"
            :stroke="gapBorderColor"
            :fill="gapColor"
            :opacity="gapOpacity"
            stroke-width="1"
            rx="2"
          />
          <rect
            transform="translate(0.5,0.5)"
            x="2"
            y="2"
            :width="width-4"
            :height="height-5"
            :stroke="strokeColor"
            :fill="fill"
            :fill-opacity="bgOpacity"
            stroke-width="1"
            rx="2"
          />
        </template>
        <!-- Fluid Ending -->
        <template v-if="!reservation.fixedEnding">
          <!-- Reservation Gap -->
          <path
            v-if="reservationGap > 0"
            transform="translate(0.5,0.5)"
            :d="bgPathGap"
            :stroke="gapBorderColor"
            :fill="gapColor"
            :opacity="gapOpacity"
            stroke-width="1"
          />
          <!-- Reservation Timeline item -->
          <path
            v-if="!reservation.fixedEnding"
            transform="translate(0.5,0.5)"
            :d="bgPath"
            :stroke="strokeColor"
            :fill="fill"
            :opacity="bgOpacity"
            stroke-width="1"
          />
        </template>
        <!-- //Fluid Ending -->
      </svg>
      <div
        :style="`position: absolute; width: ${width}px`"
        class="d-flex align-center w-100"
      >
        <div
          v-if="!isBlock"
          class="text-center font-weight-bold flex-shrink-0 flex-grow-1 tt-reservation-partysize-compact"
        >
          {{ reservation.partySize }}
        </div>
      </div>
    </div>
    <time-table-striped-fill
      v-if="isMovementBlocked"
      :pattern-id="`tt-pattern-stripe-${reservation.id}`"
      :fill-light="fillColor"
      :invert="isBlock && overbooked"
      :fill-dark="darkenColor(fillColor, isBlock ? 30 : 15)"
    />
  </div>
</template>

<script setup lang="ts">
import Reservation, { ReservationStatus } from '@/model/Reservation';
import {
  computed, onBeforeUnmount, PropType, Ref, ref,
} from 'vue';
import moment from 'moment';
import { contrastForColor, darkenColor } from '@/services/color-utils';
import { useVuetify } from '@/components/helpers/vue2-helpers';
import TimeTableStripedFill from './TimeTableStripedFill.vue';

const $vuetify = useVuetify();

const props = defineProps({
  reservation: { type: Object as PropType<Reservation>, required: true },
  slotWidth: { type: Number, required: true },
  rowHeight: { type: Number, required: true },
  rowSpan: { type: Number, required: false, default: 1 },
  timelineStart: { type: Date, required: true },
  selected: { type: Boolean, required: false, default: false },
  overbooked: { type: Boolean, required: false, default: false },
});
const root = ref(null) as Ref<null | HTMLElement>;
const emit = defineEmits(['show-tooltip', 'hide-tooltip', 'context-menu', 'click-event']);

const gapColor = '#D6D6D8';
const gapBorderColor = '#858593';
const gapOpacity = '0.6';

onBeforeUnmount(() => ((root.value as HTMLElement).classList.remove('tt-event')));

const hoverTimeout = ref(undefined) as Ref<undefined | number>;

// relative pos from left, difference between timeline and res. start
const left = computed(() => {
  const startTime = moment(props.reservation.dateBegin);
  const minutesFromStart = moment.duration(startTime.diff(props.timelineStart)).asMinutes();
  const offsetFromStart = (minutesFromStart / 30) * props.slotWidth;
  return offsetFromStart;
});

// + 1 is compensation for border, the divs are aligned over the border lines
const height = computed(() => props.rowHeight * props.rowSpan + 1);

const width = computed(() => {
  const startTime = moment(props.reservation.dateBegin);
  const endTime = moment(props.reservation.dateEnd);
  const duration = moment.duration(endTime.diff(startTime)).asMinutes();
  return (duration / 30) * props.slotWidth;
});

// gap between reservations, no gap shown for block
const reservationGap = computed(
  () => (props.reservation.isBlock ? 0 : ((props.reservation.tab?.bookingCap || 0) / 30) * props.slotWidth),
);

const isNarrowWidth = computed(() => width.value <= 100);
const isMovementBlocked = computed(() => props.reservation.partySize === 0 || props.reservation.holdTabItems);
const isBlock = computed(() => props.reservation.isBlock);
const hasTabItems = computed(() => props.reservation.tabItems.find((o) => o.isDummy) === undefined);

// Colors
const fillColor = computed(() => {
  if (isBlock.value) {
    // eslint-disable-next-line no-nested-ternary
    const color = props.overbooked ? '#800016' : ($vuetify.theme.dark ? '#666668' : '#C6C6C8');
    return props.selected ? darkenColor(color, 31) : color;
  }

  if (props.overbooked || !hasTabItems.value) {
    return props.selected ? darkenColor('#FF002B', 51) : '#FF002B'; // error
  }

  let color = '#3355FF';
  switch (props.reservation.status) {
    case ReservationStatus.CheckedIn: color = '#FF8262'; break;// 'orange';
    case ReservationStatus.Seated: color = '#00A26F'; break; // 'green';
    case ReservationStatus.NonConfirmed: color = '#E42DD0'; break; // 'purple';
    case ReservationStatus.CheckedOut: color = '#858593'; break; // gray-50
    default: break;
  }
  return props.selected ? darkenColor(color, 51) : color;
});

const strokeColor = computed(() => (isBlock.value ? '#3F3F49' : darkenColor(fillColor.value, 51)));

const bgOpacity = computed(() => (props.overbooked ? 0.8 : 1));

const fill = computed(
  () => (isMovementBlocked.value ? `url(#tt-pattern-stripe-${props.reservation.id})` : fillColor.value),
);

// Chips
const colorForLabel = computed(() => {
  if (props.reservation.label?.color === fillColor.value) return '#FFFFFF';
  return props.reservation.label?.color;
});

// paths to draw the event
const partysizeBgPath = computed(() => {
  const p = 2; const r = 4; const w = 24;
  const h = height.value - p * 2 - 1;
  return `M${r + p} ${p}
          h${w - r / 2}
          v${h}
          h-${w - r / 2}
          a${r},${r} 0,0,1 -${r},-${r}
          v-${h - r * 2}
          a${r},${r} 0,0,1 ${r},-${r}`;
});

const bgPath = computed(() => {
  const p = 2;
  const r = isNarrowWidth.value ? 2 : 4;
  const capLimit = Math.max(9, Math.min(15 * props.rowSpan, (width.value / 5)));
  const cp = isNarrowWidth.value ? 4 : 7; // control point for quadcurve
  const h = height.value - p * 2 - 1;
  const w = width.value - 1;

  return `M${r + p} ${p} H${w - capLimit}
              q${cp},0 ${capLimit} ${h / 2}
              q-${capLimit - cp},${h / 2} -${capLimit} ${h / 2}
              h-${w - r - capLimit - p}
              a${r},${r} 0,0,1 -${r},-${r}
              v-${h - r * 2}
              a${r},${r} 0,0,1 ${r},-${r}`;
});

const bgPathGap = computed(() => {
  const p = 2;
  const r = isNarrowWidth.value ? 2 : 4;
  const capLimit = Math.max(9, Math.min(15 * props.rowSpan, (width.value / 5)));
  const cp = isNarrowWidth.value ? 4 : 7; // control point for quadcurve
  const h = height.value - p * 2 - 1;
  const w = width.value + reservationGap.value - 1;

  return `M${r + p} ${p} H${w - capLimit}
              q${cp},0 ${capLimit} ${h / 2}
              q-${capLimit - cp},${h / 2} -${capLimit} ${h / 2}
              h-${w - r - capLimit - p}
              a${r},${r} 0,0,1 -${r},-${r}
              v-${h - r * 2}
              a${r},${r} 0,0,1 ${r},-${r}`;
});

// Mouse Handlers
function mouseEnter(evt: MouseEvent) {
  if (evt.buttons !== 0) { return; }
  window.clearTimeout(hoverTimeout.value);
  hoverTimeout.value = window.setTimeout(() => {
    emit('show-tooltip', root.value);
  }, 700);
}
function mouseMove(evt: MouseEvent) {
  if (evt.buttons !== 0) { return; }
  mouseEnter(evt);
}
function mouseLeave() {
  emit('hide-tooltip');
  window.clearTimeout(hoverTimeout.value);
}
function onRightClick(e: MouseEvent) {
  // do not trigger right click if it originated on touch device (long touch == right click)
  // as this will interfere with drag and drop
  if (e.buttons === 0) { return; }
  emit('context-menu', props.reservation, e);
}
function onClick(e: any) {
  // see drag and drop mixin for explanation of this
  const element = root.value as HTMLElement;
  if (element.dataset.dnd === '1') {
    element.dataset.dnd = '0';
    return;
  }

  emit('click-event', props.reservation, e);
}

</script>
